export default __webpack_public_path__ + "static/media/class_as_mentor.7f265151.svg";